<template>
    <!-- <v-card v-if="pPriAlumno"> -->
    <v-card>
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row>
            <v-col cols="4">
                <v-card>
                    <v-img src="@/assets/images/fondo1.png" height="100px">
                        <v-row justify="space-around">
                            <v-avatar size="80">
                                <img v-if="pPriAlumno.Sexo=='F'" src="@/assets/images/user2.jpg" alt="Alumno">
                                <img v-else src="@/assets/images/user1.jpg" alt="Alumno">
                            </v-avatar>
                        </v-row>
                    </v-img>
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-subtitle>{{pPriAlumno.Alumno}}</v-list-item-subtitle><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{pPriAlumno.priservicio.Iniciales}}</v-list-item-title><v-list-item-subtitle>Programa de Estudios</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>credit_card</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{pPriAlumno.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>qr_code_2</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title><v-chip color="success" dark>{{pPriAlumno.Codigo}}</v-chip></v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item v-if="dMatMatricula">
                            <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dMatMatricula.matseccion.matperiodo.Nivel}}°{{dMatMatricula.matseccion.Seccion}} {{dMatMatricula.matseccion.matperiodo.Anio}}-{{dMatMatricula.matseccion.matperiodo.Periodo}}</v-list-item-title><v-list-item-subtitle>Sección</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-icon><v-icon>tag</v-icon></v-list-item-icon>
                            <v-list-item-content><v-list-item-title>{{dNroCambio}}</v-list-item-title><v-list-item-subtitle>Nro Cambios de Carrera</v-list-item-subtitle></v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
            <v-col v-if="dMessage.length != 0" cols="8">
                <v-alert text prominent type="error" border="top">
                    <h4>No puede hacer cambio de carrera:</h4>
                    <ul>
                        <li v-for="(item,index) in dMessage" :key="index">{{item}}</li>
                    </ul>
                </v-alert>
            </v-col>
            <v-col v-else cols="8">
                <v-form ref="refMain">
                    <v-row>
                        <v-col cols="12" xm="12" sm="6" md="6" class="pa-1">
                            <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                                :items="dServicios"  item-value="IdServicio" item-text="Descripcion2"
                                :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" xm="12" sm="6" md="6" class="pa-1">
                            <v-select v-model="dIdSeccion" label="* Sección" :items="dSecciones" item-value="IdSeccion" item-text="Seccion" :disabled="dIsUpdating" filled prepend-inner-icon="label" :rules="[v => !!v || 'El campo es requerido']"></v-select>                        
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xm="12" sm="12" class="pa-1">
                            <v-text-field v-model="dobservacion" label="* Justificación" filled prepend-inner-icon="receipt" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']" :maxlength="100" autocomplete="off"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xm="12" sm="6" md="6" class="pa-1">
                            <template v-if="dIngCronogramaPagos1.length != 0">
                                <v-simple-table dense>
                                    <template>
                                        <thead>
                                            <tr style="background: #4CAF50">
                                                <th class="text-center white--text" COLSPAN="2">ACTUAL CRONOGRAMA</th>
                                            </tr>
                                            <tr style="background: #4CAF50">
                                                <th class="text-center white--text">MES</th>
                                                <th class="text-center white--text">MONTO</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in dIngCronogramaPagos1" :key="item.IdMes" style="border-bottom:2pt solid black;">
                                                <td class="text-center">{{fuMes(item.IdMes)}}</td>
                                                <td class="text-center">s/. {{ item.Monto }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </template>
                        </v-col>
                        <v-col cols="12" xm="12" sm="6" md="6" class="pa-1">
                            <template v-if="dIngCronogramaPagos2.length != 0">
                                <v-simple-table dense>
                                    <template>
                                        <thead>
                                            <tr style="background: #2196F3">
                                                <th class="text-center white--text" COLSPAN="2">NUEVO CRONOGRAMA</th>
                                            </tr>
                                            <tr style="background: #2196F3">
                                                <th class="text-center white--text">MES</th>
                                                <th class="text-center white--text">MONTO</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in dIngCronogramaPagos2" :key="item.IdMes" style="border-bottom:2pt solid black;">
                                                <td class="text-center">{{fuMes(item.IdMes)}}</td>
                                                <td class="text-center">s/. {{ item.Monto }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </template>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-btn @click.prevent="fuSave" :loading="dIsUpdating" color="primary"><v-icon left>save</v-icon> Guardar</v-btn>
                    </v-card-actions>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Close</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'ServicioCambio',
    mounted(){
        this.fuLoad(this.pPriAlumno.IdAlumno);
    },
    props: {
        pPriAlumno: {
            default: null,
            type: Object
        },
    },
    data: () => ({
        dIsUpdating: false,
        dIdSeccion: null,
        dIdServicio: null,
        dIngCronogramaPagos1: [],
        dIngCronogramaPagos2: [],
        dLoading: false,
        dMatMatricula: null,
        dMessage: [],
        dNroCambio: 0,
        dobservacion: '',
        dPeriodoSeccion: "",
        dSecciones: [],
        dServicios: [],
        dSnackbar: false,
    }),
    watch: {
        pPriAlumno: function (val) {
            if(val){
                this.fuLoad(val.IdAlumno);
            }
        },
        dIdServicio: function (val) {
            if(val){
                this.fumatseccionByServicioByNivelByFechaInicio(val);
            }
        },
        dIdSeccion (val) {
            this.dSecciones.forEach((item) => {
                if(item.IdSeccion == val){
                    this.dIngCronogramaPagos2 = item.ingcronogramapagos;
                }
            })
        }
    },
    computed: {
        ...mapState(['ssUser', 'ssPriServiciosIngreso']),
    },
    methods: {
        async fuLoad(aIdAlumno){
            if(aIdAlumno){
                this.dLoading = true;
                try {
                    let ahora = moment().format("YYYY-MM-DD");

                    const response = await this.$apollo.query({
                        query: gql`query load($IdAlumno: ID!, $token: String){
                            matmatriculaLast(IdAlumno:$IdAlumno){
                                IdMatricula
                                matseccion{
                                    IdSeccion
                                    Seccion
                                    matperiodo{
                                        Nivel
                                        Anio
                                        Periodo
                                    }
                                    ingcronogramapagos{
                                        IdMes
                                        FechaDeuda
                                        Monto
                                    }
                                }
                            }
                            prialumno(IdAlumno:$IdAlumno, token:$token){
                                admconfigperiodo{
                                    FechaFin
                                }
                            }
                            audserviciocambioByIdAlumno(IdAlumno:$IdAlumno){
                                id
                            }
                        }`,fetchPolicy: 'no-cache',
                        variables: {
                            IdAlumno: aIdAlumno,
                            token: ahora
                        }
                    })
                    this.dMatMatricula = response.data.matmatriculaLast[0];
                    
                    this.dIngCronogramaPagos1 = response.data.matmatriculaLast[0].matseccion.ingcronogramapagos;
                    
                    let vFechaFin = moment(response.data.prialumno.admconfigperiodo.FechaFin).format("YYYY-MM-DD");
                    this.dNroCambio = response.data.audserviciocambioByIdAlumno.length;

                    if(this.dMatMatricula.matseccion.matperiodo.Nivel>1)
                        this.dMessage.push("No está en 1er Semestre.");
                    if(ahora > vFechaFin){
                        this.dMessage.push("El Periodo de Admision ya finalizo el día: "+vFechaFin);//+vFechaFin.getDate() + "-"+ vFechaFin.getMonth()+ "-" +vFechaFin.getFullYear());
                    }
                    if(this.dNroCambio>0){
                        Swal.fire('Información', 'El alumno ya hizo '+this.dNroCambio+' cambio(s) de carrera.', 'info')
                        if(this.dNroCambio>=3){
                            this.dMessage.push("El alumno tiene "+this.dNroCambio+" cambios de carrera que excede el número permitido.");
                        }
                    }
                    if(this.dMessage.length == 0){
                        this.fuServicioList();
                    }
                    
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
                } finally {
                    this.dLoading = false;
                }
            }
        },
        async fuServicioList() {
            this.dServicios = this.ssPriServiciosIngreso.filter(item => item.IdServicio != this.pPriAlumno.IdServicio);
        },
        async fumatseccionByServicioByNivelByFechaInicio(pIdServicio) {
            this.dSecciones = [];
            const response = await this.$apollo.query({
                query: gql`
                    query consulta($IdServicio: Int!){
                        matseccionByServicioByNivelByFechaInicio(IdServicio: $IdServicio, Nivel:1){
                            IdSeccion
                            Seccion
                            Turno
                            FechaInicio
                            HoraTurno
                            matperiodo{
                                Anio
                                Periodo
                                Nivel
                            }
                            ingcronogramapagos{
                                IdMes
                                FechaDeuda
                                Monto
                            }
                        }
                    }
                `,
                variables: {
                    IdServicio: pIdServicio
                }
            })
            this.dSecciones = response.data.matseccionByServicioByNivelByFechaInicio.map(item =>{
                var vTurno = 'Mañana';
                if(item.Turno=='T')
                    vTurno = 'Tarde';
                else if(item.Turno=="N")
                    vTurno = 'Noche';
                else if(item.Turno=="M")
                    vTurno = 'Mañana';
                else
                    vTurno = item.Turno;
                return {
                    IdSeccion: item.IdSeccion,
                    Seccion: item.matperiodo.Nivel+"° "+ item.Seccion +" "+ item.matperiodo.Anio +"-"+ item.matperiodo.Periodo +" "+ vTurno +" - "+item.HoraTurno +" - Fecha de Inicio: " + item.FechaInicio.substr(0, 10),
                    ingcronogramapagos: item.ingcronogramapagos
                };
            });
        },
        fuMes(pIdMes){
            switch (pIdMes) {
                case 0: return 'MATRICULA'; break;
                case 1: return 'ENERO'; break;
                case 2: return 'FEBRERO'; break;
                case 3: return 'MARZO'; break;
                case 4: return 'ABRIL'; break;
                case 5: return 'MAYO'; break;
                case 6: return 'JUNIO'; break;
                case 7: return 'JULIO'; break;
                case 8: return 'AGOSTO'; break;
                case 9: return 'SEPTIEMBRE'; break;
                case 10: return 'OCTUBRE'; break;
                case 11: return 'NOVIEMBRE'; break;
                case 12: return 'DICIEMBRE'; break;
            }
        },
        fuSave () {
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = true;
            } else {
                this.fuAlumnoUpdate();
            }
        },
        async fuAlumnoUpdate(){
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation mutacion($IdMatricula: Int, $IdServicio2: Int, $IdSeccion2: Int, $IdPersonal: Int, $observacion: String){
                        prialumnoAlumnoServicioCambio(IdMatricula: $IdMatricula, IdServicio2: $IdServicio2, IdSeccion2: $IdSeccion2, IdPersonal: $IdPersonal, observacion: $observacion){
                            success
                            message
                        }
                    }`,
                    variables: {
                        IdMatricula: parseInt(this.dMatMatricula.IdMatricula),
                        IdServicio2: parseInt(this.dIdServicio),
                        IdSeccion2: parseInt(this.dIdSeccion),
                        IdPersonal: this.ssUser.IdPersonal,
                        observacion: this.dobservacion,
                    }
                });
                console.log(response.data.prialumnoAlumnoServicioCambio);
                if(response.data.prialumnoAlumnoServicioCambio.success=="1"){
                    Swal.fire('Correcto', response.data.prialumnoAlumnoServicioCambio.message, 'success')
                        .then((result) => {
                            this.$router.push(`/`);
                        });
                } else {
                    Swal.fire('¡ ERROR !', response.data.prialumnoAlumnoServicioCambio.message, 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó..', 'error');
            } finally {
                this.dIsUpdating = false;
            }
        },
    },
}
</script>

<style scoped>
table thead th { text-decoration-color: white; font-size:10pt; }
</style>